module.exports = __webpack_public_path__ + "media/components/src/assets/images/action-item/add-9088cb07963045b09c5fea7d4c6bb969.svg";